import * as z from 'zod/v4';

import { countryIdSchema } from './Country.js';

export const leagueIdSchema = z.number().int().nonnegative().brand<'LeagueId'>();

export type LeagueId = z.infer<typeof leagueIdSchema>;

/**
 * TS League type
 */
export type League = z.infer<typeof leagueSchema>;

/**
 * Zod schema for League entity
 */
export const leagueSchema = z
  .object({
    id: leagueIdSchema,
    name: z.string(),
    uniqueLeagueId: z.number().optional(),
    shortName: z.string().nullish().optional(),
    code: z.number().nullish().optional(),
    printAbbreviation: z.string().nullish().optional(),
    popular: z.boolean().optional(),
    legacyKey: z.number().nullish().optional(),
    rank: z.number().optional(),
    country: z.object({
      id: countryIdSchema,
      isoCode: z.string(),
      name: z.string(),
      population: z.number().optional(),
    }),
  })
  .transform(({ country, ...restLeague }) => {
    return {
      ...restLeague,
      countryId: country.id,
    };
  });

// TODO: sportType
